import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProfileService } from '../_services/profile.service';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const profileService = inject(ProfileService);

  const userLogged = await firstValueFrom(profileService.getProfile());

  if (userLogged.result) {
    const expectedRole = route.data['expectedRole'];
    const roleUser = userLogged.result.roles[0].name;

    if (!expectedRole.includes(roleUser)) {
      if (
        route.routeConfig?.path == 'impostazioni-admin' &&
        ['admin', 'project_manager', 'hr_manager'].includes(roleUser)
      ) {
        return true;
      }

      // L'utente non ha i permessi necessari, reindirizzalo
      return router.parseUrl('/dashboard/bacheca');
    }
    return true;
  }

  // Nessun profilo -> reindirizza
  return router.parseUrl('/dashboard/bacheca');
};
